import { VanilaCardCarouselContainer } from '@marriott/mi-ui-library';

export function LoyaltyLoader() {
  const slides = Array.from({ length: 3 }, (_, index) => index);

  return (
    <VanilaCardCarouselContainer
      componentId={`legal-Loyalty-member-tier-loader`}
      variation={'standard'}
      cardCount={3}
      isCombo={() => false}
      noOfCardsTablet={2}
      noOfCards={3}
      trackingProperties={{}}
      styleclass="py-3 px-0 mt-5 legal-box-shadow t-background-color legal-loyalty-call-us"
    >
      {slides.map(slideNo => (
        <li key={slideNo}>
          <div
            data-testid="slide-content"
            id={`slide-${slideNo}`}
            className="skeleton-loader"
            style={{
              width: '15rem',
              height: '20rem',
              borderRadius: '1rem',
            }}
          ></div>
        </li>
      ))}
    </VanilaCardCarouselContainer>
  );
}
